import { render, staticRenderFns } from "./TableNotification.vue?vue&type=template&id=0c49f022&scoped=true&"
import script from "./TableNotification.vue?vue&type=script&lang=js&"
export * from "./TableNotification.vue?vue&type=script&lang=js&"
import style0 from "./TableNotification.vue?vue&type=style&index=0&id=0c49f022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49f022",
  null
  
)

export default component.exports